import { render, staticRenderFns } from "./SelectDictType.vue?vue&type=template&id=2e6cdced&scoped=true"
import script from "./SelectDictType.vue?vue&type=script&lang=js"
export * from "./SelectDictType.vue?vue&type=script&lang=js"
import style0 from "./SelectDictType.vue?vue&type=style&index=0&id=2e6cdced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6cdced",
  null
  
)

export default component.exports